import { ContentfulModule, Sys, Cta } from '@/libs/contentful/types';
import { Margins, Colorways } from '@/types/constants';
import { DocumentWithEmbeddedEntries } from '@/libs/contentful/types';

import { RecursivePartial } from '@/utils/recursivePartial';
import { CardCarouselClassNames, CardCarouselProps } from '../CardCarousel/types';

export const CONTENT_FEATURE_CAROUSEL_VARIANTS = {
  Base: 'Base',
  ITG: 'ITG',
} as const;

export type ContentFeatureCarouselVariant =
  (typeof CONTENT_FEATURE_CAROUSEL_VARIANTS)[keyof typeof CONTENT_FEATURE_CAROUSEL_VARIANTS];

export interface ContentFeatureCarouselClassNames {
  section: string;
  wrapper: string;

  header: {
    wrapper: string;
    eyebrow: string;
    headline: string;
  };

  copy: string;

  cta: string;

  cardCarousel: RecursivePartial<CardCarouselClassNames>;
}

export interface ContentFeatureCarouselProps extends ContentfulModule {
  sys: Sys;

  margins: Margins;
  color: Colorways;
  variant?: ContentFeatureCarouselVariant;
  eyebrow: DocumentWithEmbeddedEntries;
  headline: DocumentWithEmbeddedEntries;
  copy: DocumentWithEmbeddedEntries;
  cta: Cta;

  cardCarousel: CardCarouselProps;

  className?: RecursivePartial<ContentFeatureCarouselClassNames>;
}
